var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer mt-auto"},[_c('Delivery',{attrs:{"content":_vm.replacementContent}}),_vm._v(" "),_c('Links'),_vm._v(" "),_c('Payments',{attrs:{"content":_vm.paymentContent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }